import { Fragment, useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import Navbar from "./navbar";
import ConfigNavbarWrapper from "./config-navbar/ConfigNavbarWrapper";
import { PAGES_LIST } from "../utils/constants";
import GetAuthContext from "../context/AuthContext";
import { whiteLabelStyling } from "../utils/Global";
import { getTokenFromStorage } from "../services/Fetch";
import { showMyQueue } from "@unified-dashboard/src/shared/utils/Global";
import { useRenderStrategy } from "@unified-dashboard/src/shared/hooks/useRenderStrategy";

const forbiddenRoutes = [
  "signin",
  "reset-password",
  "verify-account-details",
  "/verify-mobile-password",
  "/verify-otp",
  "/authenticate",
  "/password-expire",
  "/signin-mobile"
];

function Layout() {
  const whiteLabelStyle = whiteLabelStyling(window.location.host);

  const navigate = useNavigate();
  const { userState, logout } = GetAuthContext();
  const { organizationID } = userState;
  const { isConfigDrivenNavbar } = useRenderStrategy();
  const [appReady, setAppReady] = useState(false);

  const isMobile = window.innerWidth < 640;

  const showMyQueueFlag = showMyQueue(organizationID ?? "");

  const defaultLandingPage = showMyQueueFlag
    ? "/my-queue"
    : isMobile
      ? "/home"
      : "/leads";

  useEffect(() => {
    const token = getTokenFromStorage();
    const currentRoute = window.location.href;
    const shouldRedirectToSignIn = !forbiddenRoutes.some(
      (route) => currentRoute.indexOf(route) !== -1
    );

    if (token) {
      if (
        currentRoute.indexOf("signin") > -1 ||
        window.location.pathname === "/"
      ) {
        const userPermissions = userState?.permissions ?? {};
        if (
          Object.keys(userPermissions)?.length === 1 &&
          userPermissions?.[PAGES_LIST.ADMIN_PAGE]
        ) {
          navigate("/admin/user", {
            replace: true
          });
        } else if (Object.keys(userPermissions)?.length != 0) {
          navigate(defaultLandingPage, {
            replace: true
          });
        }
      }
    } else if (shouldRedirectToSignIn) {
      if (!window.location.pathname.includes("sso_sign_in")) {
        navigate("/signin", { replace: true });
        logout();
      }
    }

    setAppReady(true);
  }, [userState]);

  const getContainerClassName = () => {
    if (showMyQueueFlag && window.location.pathname.includes("my-queue")) {
      return "mx-auto max-w-screen-3xl h-full";
    }
    return "mx-auto max-w-screen-3xl h-full sm:px-4 sm:px-22 lg:px-14";
  }

  return (
    <Fragment>
      {isConfigDrivenNavbar ? <ConfigNavbarWrapper /> : <Navbar />}
      <div className="flex-1 min-h-0">
        <div className={getContainerClassName()}>
          {appReady ? (
            <Outlet context={{ whiteLabelStyle }} />
          ) : null}
        </div>
      </div>
    </Fragment>
  );
}

export default Layout;